/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationRelationshipResponseDto
 */
export interface CreateOrganizationRelationshipResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRelationshipResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRelationshipResponseDto
     */
    relationType: CreateOrganizationRelationshipResponseDtoRelationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRelationshipResponseDto
     */
    orgId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRelationshipResponseDto
     */
    partnerOrgId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRelationshipResponseDto
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateOrganizationRelationshipResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateOrganizationRelationshipResponseDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const CreateOrganizationRelationshipResponseDtoRelationTypeEnum = {
    Client: 'CLIENT',
    Landlord: 'LANDLORD',
    Oem: 'OEM'
} as const;
export type CreateOrganizationRelationshipResponseDtoRelationTypeEnum = typeof CreateOrganizationRelationshipResponseDtoRelationTypeEnum[keyof typeof CreateOrganizationRelationshipResponseDtoRelationTypeEnum];


/**
 * Check if a given object implements the CreateOrganizationRelationshipResponseDto interface.
 */
export function instanceOfCreateOrganizationRelationshipResponseDto(value: object): value is CreateOrganizationRelationshipResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('relationType' in value) || value['relationType'] === undefined) return false;
    if (!('orgId' in value) || value['orgId'] === undefined) return false;
    if (!('partnerOrgId' in value) || value['partnerOrgId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function CreateOrganizationRelationshipResponseDtoFromJSON(json: any): CreateOrganizationRelationshipResponseDto {
    return CreateOrganizationRelationshipResponseDtoFromJSONTyped(json, false);
}

export function CreateOrganizationRelationshipResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRelationshipResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'relationType': json['relationType'],
        'orgId': json['orgId'],
        'partnerOrgId': json['partnerOrgId'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function CreateOrganizationRelationshipResponseDtoToJSON(json: any): CreateOrganizationRelationshipResponseDto {
    return CreateOrganizationRelationshipResponseDtoToJSONTyped(json, false);
}

export function CreateOrganizationRelationshipResponseDtoToJSONTyped(value?: CreateOrganizationRelationshipResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'relationType': value['relationType'],
        'orgId': value['orgId'],
        'partnerOrgId': value['partnerOrgId'],
        'notes': value['notes'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

